import { Outlet } from "react-router-dom";
import styled from "styled-components";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { RoundedContainer } from "../components/RoundedContainer";
import { LandingLinks } from "../utils/NavLinks";

const StyledLayout = styled.div<{ $bg?: string }>`
    padding: var(--margin-page);
    padding-right: var(--margin-page-right);
    width: 100%;
    max-width: 100vw;
    min-width: 0;
    position: relative;
    background: ${(p) => p.$bg || "#fff"};
    overflow-x: hidden;
    box-sizing: border-box;
`;

const Layout = (props: { bg?: string }) => {
  const { bg } = props;
  return (
    <StyledLayout $bg={bg}>
      <Navbar links={LandingLinks} />

      <RoundedContainer
        $background="linear-gradient(180deg, rgba(var(--color-primary-rgb), 0.15) 0%, rgba(var(--color-primary-rgb), 0) 100vh)"
        style={{ minHeight: "calc(100vh - 3*64px )" }}
        $spaceoutnavbar
      >
        <Outlet />
      </RoundedContainer>

      <Footer />
    </StyledLayout>
  );
};

export default Layout;
